module.exports = __webpack_public_path__ + "img/60.85dc5514.jpg";